// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__YyHMh","empty":"ModalGraph_empty__R0lRO"};